import PageWrapper from "theme/components/wrappers/PageWrapper";
import React from "react";

const Brand = (/*{ data = {} }*/) => {
    return <PageWrapper isUnderneathNavbar>{"Brand default page"}</PageWrapper>;
};

export default Brand;
